// TOUR-22 — Manufacturing plants roster + units history orientation.
// Units live under Build pipeline → Units (not a top-level mode).

import type { FireflyTourArtifact } from "../tourTypes";

export const MFG_PLANTS_UNITS_TOUR_ID = "tour-mfg-plants-units";

export const MFG_PLANTS_UNITS_TOUR: FireflyTourArtifact = {
  id: MFG_PLANTS_UNITS_TOUR_ID,
  version: 2,
  defaultIntent: "teaching",
  intents: [
    "plants tour",
    "where units are built",
    "manufacturing plants tour",
    "units tour",
    "plant roster tour",
    "show me plants",
    "walk me through plants and units",
    "how do i see where units are built",
  ],
  bucketRelevance: ["manufacturing"],
  requiredRoles: ["manufacturing", "platform_owner", "platform_admin", "platform_dev"],
  steps: [
    {
      id: "nav-plants",
      target: {
        mode: "mfgPlants",
        anchorId: "mode-nav-mfgPlants",
        scrollIntoView: true,
      },
      deferModeNavigation: true,
      skipWhenCurrentMode: "mfgPlants",
      copy: {
        title: "Open Plants",
        body: "Production sites and dealer attachments live here. Tap Plants in the Manufacturing bucket (sidebar or bottom bar).",
      },
      waitForClick: true,
    },
    {
      id: "plants-list",
      target: { mode: "mfgPlants", anchorId: "mfg-plants-list", scrollIntoView: true },
      copy: {
        title: "Plants roster",
        body: "Each row is a production site with its own materials and WAC history. Select a plant to manage attached dealers; the org default is where new materials land.",
      },
      advanceOn: "next_button",
    },
    {
      id: "plant-detail",
      target: { mode: "mfgPlants", anchorId: "mfg-plant-detail", scrollIntoView: true },
      copy: {
        title: "Plant column",
        body: "Below the roster, the dealers-attached box shows which dealers and locations hang off the selected plant — including an Unattached bucket for dealers without a primary plant.",
      },
      advanceOn: "next_button",
    },
    {
      id: "nav-build-pipeline",
      target: {
        mode: "mfgBuildPipeline",
        anchorId: "mode-nav-mfgBuildPipeline",
        scrollIntoView: true,
      },
      deferModeNavigation: true,
      skipWhenCurrentMode: "mfgBuildPipeline",
      copy: {
        title: "Open Build pipeline",
        body: "Built and in-progress sheds live under Build pipeline. Tap Build pipeline in the Manufacturing bucket.",
      },
      waitForClick: true,
    },
    {
      id: "units-tab",
      target: {
        mode: "mfgBuildPipeline",
        anchorId: "mfg-build-pipeline-units-tab",
        scrollIntoView: true,
      },
      copy: {
        title: "Units tab",
        body: "Switch to Units for the flat roster and create flow. Plant Kanban is the phase board; Units is the list + timeline view.",
      },
      waitForClick: true,
    },
    {
      id: "units-list",
      target: { mode: "mfgBuildPipeline", anchorId: "mfg-units-list", scrollIntoView: true },
      copy: {
        title: "Units and build timeline",
        body: "Each unit keeps a permanent UUID. Rows show plant, sale path, and build timestamps (created → build started → build complete). Filter by plant when you need one site's history.",
      },
      advanceOn: "next_button",
    },
    {
      id: "ask-firefly",
      target: { mode: "mfgBuildPipeline", anchorId: "ask-firefly", scrollIntoView: true },
      copy: {
        title: "Ask Firefly anytime",
        body: "Material costs and WAC live under Inventory — a separate tour. Ask Firefly anytime for inventory or logistics walkthroughs.",
      },
      advanceOn: "next_button",
    },
  ],
};
